<template>
  <div>
    <div
      class="modal fade in"
      id="add-item"
      @click="close()"
      v-if="!!product.id"
    >
      <div class="modal-dialog" @click.stop>
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" @click="close()">
              <i class="fas fa-times"></i>
            </button>
            <h4 class="modal-title">
              Add this Product to Order {{ order.number }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="price" :class="{ sale: product.on_sale }">
              {{ product.srp_amount | money }} /
              {{ product.unit_of_measure | unit-of-measure 1 true }}
            </div>

            <div class="basic-details">
              <span class="brand">{{ product.brand }}</span>
              <h4>{{ product.name }}</h4>
              <code>{{ product.upc_13 }}</code>
            </div>

            <div class="facets">
              <component
                :is="facetComponent(facet)"
                v-for="facet in facets"
                :facet="facet"
                v-ref:facets
              ></component>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn" @click="close()">Cancel</button>
            <span class="btn btn-primary add-item" @click="save()">
              <span v-if="saving">
                <i class="fas fa-circle-notch fa-spin"></i>
                Adding Item...
              </span>
              <span v-else>Add Item</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActsAsModal from 'mixins/ActsAsModal';
import InteractsWithState from 'mixins/InteractsWithState';
import Stash from 'src/stash';
import SingleFacet from 'components/SingleFacet';
import MultiFacet from 'components/MultiFacet';
import Vue from 'vue';
import _ from 'lodash';
import moment from 'moment';
import { Api } from 'src/utilities';
import { quantities, QUANTITY_ID } from 'src/stubs';

export default {
  mixins: [ActsAsModal, InteractsWithState],

  props: [
    {
      name: 'order',
      type: Object,
      default: {},
    },
  ],

  data() {
    return {
      saving: false,
    };
  },

  computed: {
    product() {
      return this.state.product;
    },

    price() {
      const p = this.product;
      const price =
        p.on_sale && p.sale_srp_amount > 0 ? p.sale_srp_amount : p.srp_amount;

      return price;
    },

    facets() {
      const quantity = {
        name: 'Quantity',
        id: QUANTITY_ID,
        required: true,
        choice_limit: 1,
        choices: {
          data: quantities[_.get(this.product, 'unit_of_measure', 'pound')],
        },
      };

      return [quantity, ...this.state.facets];
    },

    lead_time() {
      if (!this.product.lead_time) {
        return null;
      }

      return moment().add(this.product.lead_time, 'm').fromNow(true);
    },

    quantity() {
      const preference = this.preferences.find(p => p.facet_id === QUANTITY_ID);

      if (preference) {
        return preference.choice_id;
      }
    },

    preferences() {
      return this.state.preferences;
    },
  },

  methods: {
    close() {
      Stash.setProduct();
    },

    async save() {
      if (!this.validate()) {
        return;
      }

      this.saving = true;

      const qty = this.$refs.facets.find(c => c.facet.name === 'Quantity');
      const facets = this.$refs.facets.filter(c => c.facet.name !== 'Quantity');

      const data = {
        order_id: this.order.id,
        product_id: this.product.id,
        quantity: this.quantity,
        preferences: this.preferences.filter(p => p.facet_id !== QUANTITY_ID),
      };

      try {
        const response = await Api.post('items', {
          data,
          channel: 'foreground',
        });

        Stash.addItem(this.order.id, response.data);
        Stash.setProduct();
      } finally {
        this.saving = false;
      }
    },

    validate() {
      return (this.valid =
        !this.$refs.facets.map(f => !f.validate()).filter(v => v).length > 0);
    },

    // Determine the facet component to use based on the choice_limit seen in
    // the API repsonse.
    //
    // - SingleFacet: a select list compmonent allowing a single choice to be selected
    // - MultiFacet: a set of checkboxes allowing multiple choices to be selected
    //
    facetComponent(facet) {
      return facet.choice_limit === 1 ? 'single-facet' : 'multi-facet';
    },
  },

  components: { SingleFacet, MultiFacet },
};
</script>

<style lang="scss" scoped>
.price {
  float: right;

  &.sale {
    color: red;
  }
}

.facets {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// AddProduct.vue?53d8a271